export const handleResetPassword = async (
  method: () => Promise<any>,
  addToast: (options: {
    title: string;
    description: string;
    status: "success" | "error";
  }) => void,
) => {
  try {
    const response = await method();
    if (response.status === 200) {
      addToast({
        title: "Sucesso",
        description: "Reposição de senha enviada",
        status: "success",
      });
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error("API Error:", error);
    addToast({
      status: "error",
      title: "Erro",
      description: "Ocorreu um erro ao eniar o senha",
    });
  }
};
